if (!window.Eurus.loadedScript.has('shipping-policy.js')) {
  window.Eurus.loadedScript.add('shipping-policy.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xShippingPolicy', (url) => ({
        show: false,
        htmlInner: '',
        opener: null,
        loadShipping() {
          this.opener = document.activeElement;
          this.show = true;
          Alpine.store('xPopup').open = true;
          this.$nextTick(() => this.shippingFocus());
          fetch(url)
            .then(response => {
              if (!response.ok) throw new Error(`Shipping policy failed with status ${response.status}`);
              return response.text();
            })
            .then(data => {
              const parser = new DOMParser();
              const text = parser.parseFromString(data, 'text/html');
              const policy = text.querySelector('.shopify-policy__container');
              if (policy) this.htmlInner = policy.innerHTML;
            })
            .catch(() => {
              this.htmlInner = '';
            });
        },
        closeShipping() {
          if (!this.show) return;
          this.show = false;
          Alpine.store('xPopup').close();
          this.$nextTick(() => this.shippingRemoveFocus());
        },
        shippingFocus() {
          requestAnimationFrame(() => {
            const closeButton = document.getElementById('CloseShopping');
            closeButton?.focus();
            setTimeout(() => {
              if (this.show && document.activeElement !== closeButton) closeButton?.focus();
            }, 350);
          });
        },
        trapShippingFocus(event) {
          if (event.key !== 'Tab') return;
          const popup = document.getElementById('ShippingPolicyPopup');
          if (!popup) return;
          const focusable = Array.from(popup.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )).filter((element) => !element.hidden && element.offsetParent !== null);
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        },
        shippingRemoveFocus() {
          const activeElement = this.opener?.isConnected ? this.opener : document.getElementById('LoadShoppingPolicy');
          activeElement?.focus();
          this.opener = null;
        }
      }))
    })
  });
}
